import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['announcementsBadge']

  connect() {
    if (window.localStorage.getItem('announcements-singlecalc-dismissed')) { // TODO: This key is temporary (See https://vesselindex-team.atlassian.net/browse/VI-1437)
      this.hideAnnouncementsBadge()
    }

    window.addEventListener('announcements:dismissed', this.hideAnnouncementsBadge.bind(this))
  }

  hideAnnouncementsBadge() {
    this.announcementsBadgeTarget.classList.add('d-none')
  }

  showAnnouncementsModal() {
    this.dispatch('show-announcements')
  }
}